/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CheckFacultyEmailsBody } from '../models';
// @ts-ignore
import type { CheckFacultyEmailsResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ExtractEmailsResponse } from '../models';
// @ts-ignore
import type { FacultyInviteResponse } from '../models';
// @ts-ignore
import type { GetFacultyInvitesResponse } from '../models';
// @ts-ignore
import type { InviteFacultyBody } from '../models';
// @ts-ignore
import type { InviteFacultyResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
/**
 * FacultyInviteAdminApiApi - axios parameter creator
 */
export const FacultyInviteAdminApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CheckFacultyEmailsBody} checkFacultyEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiCheckFacultyEmails: async (checkFacultyEmailsBody: CheckFacultyEmailsBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checkFacultyEmailsBody' is not null or undefined
            assertParamExists('facultyInviteAdminApiCheckFacultyEmails', 'checkFacultyEmailsBody', checkFacultyEmailsBody)
            const localVarPath = `/api/v1/admin/faculty/invites/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkFacultyEmailsBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} rosterFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiExtractFacultyEmails: async (rosterFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'rosterFile' is not null or undefined
            assertParamExists('facultyInviteAdminApiExtractFacultyEmails', 'rosterFile', rosterFile)
            const localVarPath = `/api/v1/admin/faculty/invites/extract-emails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (rosterFile !== undefined) { 
                localVarFormParams.append('roster_file', rosterFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InviteFacultyBody} inviteFacultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiInviteFaculty: async (inviteFacultyBody: InviteFacultyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteFacultyBody' is not null or undefined
            assertParamExists('facultyInviteAdminApiInviteFaculty', 'inviteFacultyBody', inviteFacultyBody)
            const localVarPath = `/api/v1/admin/faculty/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteFacultyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {FacultyInviteAdminApiListFacultyInvitesStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiListFacultyInvites: async (page?: number, pageSize?: number, search?: string | null, status?: FacultyInviteAdminApiListFacultyInvitesStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/faculty/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiResendFacultyInvite: async (inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('facultyInviteAdminApiResendFacultyInvite', 'inviteId', inviteId)
            const localVarPath = `/api/v1/admin/faculty/invites/{invite_id}/resend`
                .replace('{invite_id}', encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiRevokeFacultyInvite: async (inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('facultyInviteAdminApiRevokeFacultyInvite', 'inviteId', inviteId)
            const localVarPath = `/api/v1/admin/faculty/invites/{invite_id}`
                .replace('{invite_id}', encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacultyInviteAdminApiApi - functional programming interface
 */
export const FacultyInviteAdminApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacultyInviteAdminApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CheckFacultyEmailsBody} checkFacultyEmailsBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiCheckFacultyEmails(checkFacultyEmailsBody: CheckFacultyEmailsBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckFacultyEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiCheckFacultyEmails(checkFacultyEmailsBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiCheckFacultyEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} rosterFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiExtractFacultyEmails(rosterFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtractEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiExtractFacultyEmails(rosterFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiExtractFacultyEmails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {InviteFacultyBody} inviteFacultyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiInviteFaculty(inviteFacultyBody: InviteFacultyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InviteFacultyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiInviteFaculty(inviteFacultyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiInviteFaculty']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [search] 
         * @param {FacultyInviteAdminApiListFacultyInvitesStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiListFacultyInvites(page?: number, pageSize?: number, search?: string | null, status?: FacultyInviteAdminApiListFacultyInvitesStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFacultyInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiListFacultyInvites(page, pageSize, search, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiListFacultyInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiResendFacultyInvite(inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FacultyInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiResendFacultyInvite(inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiResendFacultyInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} inviteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async facultyInviteAdminApiRevokeFacultyInvite(inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.facultyInviteAdminApiRevokeFacultyInvite(inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacultyInviteAdminApiApi.facultyInviteAdminApiRevokeFacultyInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacultyInviteAdminApiApi - factory interface
 */
export const FacultyInviteAdminApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacultyInviteAdminApiApiFp(configuration)
    return {
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiCheckFacultyEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiCheckFacultyEmails(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiCheckFacultyEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckFacultyEmailsResponse> {
            return localVarFp.facultyInviteAdminApiCheckFacultyEmails(requestParameters.checkFacultyEmailsBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiExtractFacultyEmailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiExtractFacultyEmails(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiExtractFacultyEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ExtractEmailsResponse> {
            return localVarFp.facultyInviteAdminApiExtractFacultyEmails(requestParameters.rosterFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiInviteFacultyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiInviteFaculty(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiInviteFacultyRequest, options?: RawAxiosRequestConfig): AxiosPromise<InviteFacultyResponse> {
            return localVarFp.facultyInviteAdminApiInviteFaculty(requestParameters.inviteFacultyBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiListFacultyInvitesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiListFacultyInvites(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiListFacultyInvitesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetFacultyInvitesResponse> {
            return localVarFp.facultyInviteAdminApiListFacultyInvites(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiResendFacultyInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiResendFacultyInvite(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiResendFacultyInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<FacultyInviteResponse> {
            return localVarFp.facultyInviteAdminApiResendFacultyInvite(requestParameters.inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiRevokeFacultyInviteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        facultyInviteAdminApiRevokeFacultyInvite(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiRevokeFacultyInviteRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.facultyInviteAdminApiRevokeFacultyInvite(requestParameters.inviteId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for facultyInviteAdminApiCheckFacultyEmails operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiCheckFacultyEmailsRequest {
    readonly checkFacultyEmailsBody: CheckFacultyEmailsBody
}

/**
 * Request parameters for facultyInviteAdminApiExtractFacultyEmails operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiExtractFacultyEmailsRequest {
    readonly rosterFile: File
}

/**
 * Request parameters for facultyInviteAdminApiInviteFaculty operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiInviteFacultyRequest {
    readonly inviteFacultyBody: InviteFacultyBody
}

/**
 * Request parameters for facultyInviteAdminApiListFacultyInvites operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiListFacultyInvitesRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly search?: string | null

    readonly status?: FacultyInviteAdminApiListFacultyInvitesStatusEnum
}

/**
 * Request parameters for facultyInviteAdminApiResendFacultyInvite operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiResendFacultyInviteRequest {
    readonly inviteId: string
}

/**
 * Request parameters for facultyInviteAdminApiRevokeFacultyInvite operation in FacultyInviteAdminApiApi.
 */
export interface FacultyInviteAdminApiApiFacultyInviteAdminApiRevokeFacultyInviteRequest {
    readonly inviteId: string
}

/**
 * FacultyInviteAdminApiApi - object-oriented interface
 */
export class FacultyInviteAdminApiApi extends BaseAPI {
    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiCheckFacultyEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiCheckFacultyEmails(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiCheckFacultyEmailsRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiCheckFacultyEmails(requestParameters.checkFacultyEmailsBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiExtractFacultyEmailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiExtractFacultyEmails(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiExtractFacultyEmailsRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiExtractFacultyEmails(requestParameters.rosterFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiInviteFacultyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiInviteFaculty(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiInviteFacultyRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiInviteFaculty(requestParameters.inviteFacultyBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiListFacultyInvitesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiListFacultyInvites(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiListFacultyInvitesRequest = {}, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiListFacultyInvites(requestParameters.page, requestParameters.pageSize, requestParameters.search, requestParameters.status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiResendFacultyInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiResendFacultyInvite(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiResendFacultyInviteRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiResendFacultyInvite(requestParameters.inviteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FacultyInviteAdminApiApiFacultyInviteAdminApiRevokeFacultyInviteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public facultyInviteAdminApiRevokeFacultyInvite(requestParameters: FacultyInviteAdminApiApiFacultyInviteAdminApiRevokeFacultyInviteRequest, options?: RawAxiosRequestConfig) {
        return FacultyInviteAdminApiApiFp(this.configuration).facultyInviteAdminApiRevokeFacultyInvite(requestParameters.inviteId, options).then((request) => request(this.axios, this.basePath));
    }
}

export const FacultyInviteAdminApiListFacultyInvitesStatusEnum = {
    Invited: 'Invited',
    Accepted: 'Accepted',
    Revoked: 'Revoked',
    Expired: 'Expired',
} as const;
export type FacultyInviteAdminApiListFacultyInvitesStatusEnum = typeof FacultyInviteAdminApiListFacultyInvitesStatusEnum[keyof typeof FacultyInviteAdminApiListFacultyInvitesStatusEnum];
